import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaHourglassHalf } from "react-icons/fa";
import "./AdminApproval.css";
import brandAsureLogo from "../assets/brand_assure_logo.svg"; // ✅ Add logo import

const AdminApproval = () => {
  const navigate = useNavigate();
  const [superAdminEmail, setSuperAdminEmail] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchSuperAdminEmail = async () => {
      try {
        const response = await fetch("/mcv/get_superadmin_info");
        const data = await response.json();

        if (data.status === "SUCCESS" && data.DATA.super_admin_mail) {
          setSuperAdminEmail(data.DATA.super_admin_mail);
        } else {
          setError(true);
        }
      } catch (error) {
        console.error("Error fetching SuperAdmin info:", error);
        setError(true);
      }
    };

    fetchSuperAdminEmail();
  }, []);

  // 🔹 Logout handler (same logic as in Header)
  const handleLogout = async () => {
    try {
      const response = await fetch("/mcv/logout", {
        method: "GET",
        credentials: "include",
      });
      console.log("I'm in handleLogout of AdminApproval");

      if (response.ok) {
        // Clear all stored session/localStorage items
        localStorage.removeItem("userId");
        localStorage.removeItem("userData");
        localStorage.removeItem("userDbDefault");
        localStorage.removeItem("activeButton");
        localStorage.removeItem("isValidateOpen");
        localStorage.removeItem("isManageOpen");
        localStorage.removeItem("logoutExpiration");

        // Redirect to login
        navigate("/mcv/login");
      } else {
        console.error("Logout failed:", response);
        navigate("/mcv/login"); // still redirect
      }
    } catch (error) {
      console.error("Error logging out:", error);
      navigate("/mcv/login");
    }
  };


  return (
    <div className="admin-approval-container">
      <div className="admin-page-header">
        <img src={brandAsureLogo} alt="BrandAssure" className="admin-page-logo" />
      </div>

      <div className="admin-approval-content">
        <div className="admin-approval-header">
          <FaHourglassHalf className="approval-icon" />
          <div className="admin-approval-title">Admin Approval Required</div>
        </div>

        <p className="admin-approval-description">
          {error ? (
            "There was an issue fetching approval details. Please try again later."
          ) : (
            <>
              Your account is pending admin approval. Please contact your administrator at{" "}
              <b>{superAdminEmail}</b> for access.
            </>
          )}
        </p>

        {/* <button className="admin-approval-button" onClick={() => navigate("/mcv/login")}>
          Go to Login
        </button> */}
        <button className="admin-approval-button" onClick={handleLogout}>
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default AdminApproval;
